import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PaymentFormtype } from '../../../../shared/formtypes/payment-formtype';
import { BdoApiService } from '../../../services/bdo-api.service';
import { BankAccount } from '../../../../../assets/js/com/ts_api_client';
import { LOADING_STATE } from '../../../enums/loadingState.enum';
import { ToastService } from '../../../services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { PollService } from '../../../services/poll.service';
import { TRACKING } from '../../../enums/trackingParts.enum';
import { TrackingService } from '../../../services/tracking.service';

@Component({
    selector: 'bdo-personal-data-banking-form',
    templateUrl: './personal-data-banking-form.component.html',
    styleUrls: ['./personal-data-banking-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PersonalDataBankingFormComponent {
  @Input() formWithSepaBox: boolean = false;
  @Output() editDone: EventEmitter<BankAccount> = new EventEmitter();
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() cancel: EventEmitter<any> = new EventEmitter();
  public paymentForm = new FormGroup<PaymentFormtype>({ });
  public LoadingState = LOADING_STATE;
  public state = LOADING_STATE.IDLE;
  private bankAccountResult: BankAccount = null;

  constructor(
    private apiService: BdoApiService,
    private toastService: ToastService,
    private translateService: TranslateService,
    private pollService: PollService,
    private trackingService: TrackingService
  ) { }

  public onSubmit() {
    if (this.paymentForm.invalid) {
      this.paymentForm.markAllAsTouched();
      return;
    }

    this.state = LOADING_STATE.LOADING;

    const bankAccount: BankAccount = {
      iban: this.paymentForm.value.bankData.iban,
      accountholder: this.paymentForm.value.bankData.accountholder,
      bankname: this.paymentForm.value.bankData.bankname
    };

    this.apiService.postBankAccount(bankAccount).subscribe({
      next: (bankAccountResult: BankAccount) => {
        this.state = LOADING_STATE.IDLE;
        this.toastService.pushToast({
          headline: this.translateService.instant('personaldata.banking.success')
        });
        this.bankAccountResult = bankAccountResult;
        this.editDone.emit(this.bankAccountResult);
        this.pollService.activatePoll({ pollId: 4, triggerPoint: 'PersoenlicheDaten', extraContext: 'banking', delay: 6500 });
        this.trackingService.postSimpleTracking('Persönliche Daten Banking', TRACKING.ACTION.SUCCESS);

      }, error: () => {
        this.pollService.activatePoll({ pollId: 4, triggerPoint: 'PersoenlicheDaten', extraContext: 'banking', delay: 6500 });
        this.trackingService.postSimpleTracking('Persönliche Daten Banking', TRACKING.ACTION.FAILURE);
        this.state = LOADING_STATE.ERROR;
      }
    });
  }

}
